"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _selectors = require("../../store/selectors");
var _helpers = require("../../store/helpers");
var _actions = require("../../store/actions");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var INITIAL_SECONDS_VALUE = undefined;
var isLastTic = function isLastTic(seconds) {
  return seconds === 0;
};
var SearchButton = function SearchButton(_ref) {
  var onSearch = _ref.onSearch;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(INITIAL_SECONDS_VALUE),
    _useState2 = _slicedToArray(_useState, 2),
    secondsToNextSearch = _useState2[0],
    setSecondsToNextSearch = _useState2[1];
  var nextAvailableSearchTime = (0, _reactRedux.useSelector)(_selectors.getNextAvailableSearchTime);
  var handleClick = (0, _react.useCallback)(function () {
    if (nextAvailableSearchTime && (0, _helpers.isActualSearchTimestamp)(nextAvailableSearchTime)) {
      setSecondsToNextSearch((0, _helpers.getRestSecondsBySearchTime)(nextAvailableSearchTime));
    } else {
      onSearch();
    }
  }, [nextAvailableSearchTime, onSearch]);
  (0, _react.useEffect)(function () {
    if (secondsToNextSearch) {
      setTimeout(function () {
        return setSecondsToNextSearch(R.dec);
      }, 1000);
    } else if (isLastTic(secondsToNextSearch)) {
      dispatch((0, _actions.resetNextAvailableSearchTime)());
      setSecondsToNextSearch(INITIAL_SECONDS_VALUE);
      onSearch();
    }
  }, [secondsToNextSearch, onSearch, dispatch]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.submitButton
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    width: _Button.WIDTHS.FLUID,
    size: _Button.SIZES.LARGE,
    theme: _Button.THEMES.PURPLE,
    onClick: !secondsToNextSearch ? handleClick : undefined
  }, secondsToNextSearch ? "".concat(secondsToNextSearch, "...") : t('SEARCH_BUTTON')));
};
var _default = exports.default = (0, _react.memo)(SearchButton);